import React from 'react';

export default function CanvasStage({ canvasElementRef }) {
  return (
    <section className="manual-stage" aria-label="Canvas de edição">
      <div className="manual-stage__frame">
        <canvas ref={canvasElementRef} className="manual-stage__canvas" />
      </div>
    </section>
  );
}
